import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconVideoStyle0 = cosmosIconCss;

const CosmosIconVideo$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVideo extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c42778a309b2547ce857ff30ead1e19c5574b40b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '28bbcd5df370694f60bf6ef6928bd8f2d51c5685', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '000a2ff3ff81c30ee899511826dbcca8027542df', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-17Zm16 1.5v11h-15v-11h15ZM9 13.2V8.51a.3.3 0 0 1 .45-.26l4.41 2.47a.3.3 0 0 1 0 .53l-4.43 2.21A.29.29 0 0 1 9 13.2Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconVideoStyle0; }
}, [1, "cosmos-icon-video", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-video"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-video":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVideo$1);
            }
            break;
    } });
}

const CosmosIconVideo = CosmosIconVideo$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVideo, defineCustomElement };
